export default "__VITE_ASSET__CGY9fPGn__"